export enum WhatsappEventEnum {
  CLICKED = 'whatsapp_clicked',
}
